<!--
 라디오 버튼
------------------------------------
사용 예 )
------------------------------------
기본 옵션출력 (name 미지정 : 자동생성)
    <app-input-radio
        :options="[{text: '옵션1', val: 'a'}, {text: '옵션2', val: 'b'}]"
    > </app-input-radio>
------------------------------------
name 값 지정
    <app-input-radio
        name="radio-name"
        :options="[{text: '옵션1', val: 'a'}, {text: '옵션2', val: 'b'}]"
    > </app-input-radio>
------------------------------------
------------------------------------
값 바인딩 : 부모 컴포넌트의 data v-model 처리
    <app-input-radio
        v-model="parents_attr"
        :options="[{text: '옵션1', val: 'a'}, {text: '옵션2', val: 'b'}]"
    > </app-input-radio>
------------------------------------



------------------------------------
사이즈 설정
   제공안함 (나중에 필요시 개발진행)



------------------------------------
포커싱 기능 - 요소를 선택하면 색상이 하이라이트됨
------------------------------------
setFocus() - 요소에 포커싱 설정
    <app-input-radio
        v-model="parents_attr"
        :options="[{text: '옵션1', val: 'a'}, {text: '옵션2', val: 'b'}]"

        ref="aaa"
    > </app-input-radio>

    <button type="button" @click="$refs.aaa.inputFocus()">포커싱</button>

------------------------------------
setError() - 요소를 검증오류로 설정
    <app-input-radio
        v-model="parents_attr"
        :options="[{text: '옵션1', val: 'a'}, {text: '옵션2', val: 'b'}]"

        ref="aaa"
    > </app-input-radio>

    <button type="button" @click="$refs.aaa.setState('error', '오류메세지')">오류설정</button>
-->
<template>
    <div class="uk-flex uk-flex-left uk-flex-wrap uk-flex-middle uk-margin-small-top" :class="classObject" :style="[defaultCssVariables, cssVariables]">
        <label
            v-for="(option, index) in options"
            :key="index"

            class="uk-margin-right uk-margin-small-bottom"
        >
            <input
                type="radio"
                class="uk-radio"

                :name="radioName"
                :value="option.val"
                :checked="selectedIndex === index"

                @input="updateValue"

                @focus="focus"
                @focusout="focusout"
            />

            <slot
                name="optionText"
                :option="option"
            >
                {{ option.text }}
            </slot>
        </label>



    </div>
</template>

<script>
    import InputBase from './base.vue';
    export default {
        extends: InputBase,
        data: function () {

            return {

            };
        },
        computed: { 
            /**
             * 현재 선택된 index를 반환
             */
            selectedIndex: function () {
                var value = this.value;
                var selected = null;
                 _.find(this.options, function (option, index) {
                     if (value == option.val) {
                         selected = index;
                        return true;
                     }
                     return false;
                });
                return selected;
            },

            /**
             * 라디오 버튼 name 속성
             *  - 넘겨받은 name 값이 없으면, 자동생성된 값을 사용한다.
             *  @return string
             */
            radioName() {
                if (this.name) {
                    return this.name;
                }

                return this.get_cmp_id();
            },
        }
    }
</script>